module.exports = __webpack_public_path__ + "img/clarity.8879c24.png";